import { combineEpics, ofType } from 'redux-observable';
import { concat, merge, of } from 'rxjs';
import { filter, delay, mapTo, switchMap, mergeMap } from 'rxjs/operators';
import axios from 'axios';
import { inventoryViewApiError } from '../actions/inventories';
import { coreNetworkDropDownList, kpiCoreNetworkGraphSuccess, kpiNodesSuccess, setInventoryData } from '../actions/kpiActions';
import userService from '../services/userServices';
import { graphDataRadioApiError } from '../actions/performances';
import { SOLUTION_TYPE } from '../helpers/const';

const url = '/api/v1/kpi_query';
const pingEpic = (action$) =>
    action$.pipe(
        filter((action) => action.type === 'PING'),
        mapTo({ type: 'PONG' })
    );

const kpiListEpic = (action$) =>
    action$.pipe(
        ofType('METRICS_LIST_REQUEST'),
        switchMap(async (action) => {
            try {
                const { locationId } = action;
                console.log(`location id is ${locationId}`);
                const response = await userService.inventoryView({ locationId });
                const { enterpriseName, ecpdId, nibId, nodeName, networks, solutionType, updatedDate } = response.data;
                const nodesFilter = networks.find(({ networkType }) => networkType === 'CORE_NETWORK');
                let nodes = [];
                if (solutionType === 'NDAC') {
                    const nodeNameNDAC = nodesFilter.parentNodes.find(({ nodeType }) => nodeType === 'EDGE_CLOUD');
                    //    const nodesListCoreNdac = nodeNameNDAC?.nodeList?.map((key) => ({ key: key.nodeName, text: key.nodeName, value: key.nodeName }));
                    const nodesList5CoreNDAC = nodeNameNDAC?.nodeList;
                    nodes = nodesList5CoreNDAC?.map((key) => ({ key: key.nodeName, text: key.nodeName, value: key.nodeName }));
                } else if (solutionType === SOLUTION_TYPE.EP5G) {
                    //ep5g node
                    const nodeNameAMF = nodesFilter.parentNodes.find(({ nodeType }) => nodeType === 'AMF');
                    const nodesList5g = nodeNameAMF?.nodeList?.map((key) => ({ key: key.nodeName, text: key.nodeName, value: key.nodeName }));
                    nodes = nodesList5g;
                } else {
                    const nodeNameMME = nodesFilter?.parentNodes?.find(({ nodeType }) => nodeType === 'MME');
                    const nodeNameSaeGw = nodesFilter?.parentNodes?.find(({ nodeType }) => nodeType === 'SAE_GW');
                    const nodesList3 = nodeNameMME?.nodeList?.map((key) => ({ key: key.nodeName, text: key.nodeName, value: key.nodeName }));
                    const nodesList4 = nodeNameSaeGw?.nodeList?.map((key) => ({ key: key.nodeName, text: key.nodeName, value: key.nodeName }));
                    nodes = nodesList3?.concat(nodesList4);
                }

                return kpiNodesSuccess({ nodes, inventory: { enterpriseName, ecpdId, nibId, nodeName, networks, solutionType, updatedDate } });
            } catch (error) {
                console.log(error);
                const { message, form = {} } = error.data;
                return inventoryViewApiError(message, form);
            }
        })
    );

const kpiLoadSuccess = (action$) =>
    action$.pipe(
        ofType('KPI_LOAD_SUCCESS'),
        mergeMap((action) => {
            const actions = [];
            actions.push(of(coreNetworkDropDownList(action.response.nodes, action.response.inventory.ecpdId, action.response.inventory.nibId)));
            actions.push(of(setInventoryData(action.response.inventory)));
            return concat(...actions);
        })
    );

const requestEpgCoreNetworkEpic = (action$) =>
    action$.pipe(
        ofType('KPI_CORE_NETWORK_EPG_DATA_REQUEST'),
        switchMap(async (action) => {
            try {
                console.log('KPI_CORE_NETWORK_EPG_DATA_REQUEST called');
                const { headers } = action;
                const responses = await userService.graphDataRadio(headers[0], headers[1]);
                if (responses && responses.length > 0) {
                    console.log(responses);
                    return kpiCoreNetworkGraphSuccess(responses, true, false);
                }
            } catch (error) {
                console.log(error);
                return graphDataRadioApiError('metrix data not available', null);
            }
        })
    );

const requestMMECoreNetworkEpic = (action$) =>
    action$.pipe(
        ofType('KPI_CORE_NETWORK_MME_DATA_REQUEST'),
        switchMap(async (action) => {
            try {
                console.log('KPI_CORE_NETWORK_EPG_DATA_REQUEST called');
                const { headers } = action;
                const responses = await userService.graphDataMMECore(
                    headers[0],
                    headers[1],
                    headers[2],
                    headers[3],
                    headers[4],
                    headers[5],
                    headers[6],
                    headers[7]
                );
                if (responses && responses.length > 0) {
                    console.log(responses);
                    return kpiCoreNetworkGraphSuccess(responses, false, false);
                }
            } catch (error) {
                console.log(error);
                return graphDataRadioApiError('metrix data not available', null);
            }
        })
    );

const requestSA5GCoreNetworkEpic = (action$) =>
    action$.pipe(
        ofType('KPI_CORE_NETWORK_SA5G_AMF_DATA_REQUEST'),
        switchMap(async (action) => {
            try {
                console.log('KPI_CORE_NETWORK_SA5G_AMF_DATA_REQUEST called');
                const { headers } = action;
                const responses = await userService.graphDataSA5GAMFCore(headers[0]);
                if (responses && responses.length > 0) {
                    console.log(responses);
                    return kpiCoreNetworkGraphSuccess(responses, false, true);
                }
            } catch (error) {
                console.log(error);
                return graphDataRadioApiError('metrix data not available', null);
            }
        })
    );

const requestNDACCoreNetworkEpic = (action$) =>
    action$.pipe(
        ofType('KPI_CORE_NETWORK_NDAC_DATA_REQUEST'),
        switchMap(async (action) => {
            try {
                console.log('KPI_CORE_NETWORK_NDAC_DATA_REQUEST called');
                const { headers } = action;
                const responses = await userService.requestGetNDACGraph(headers[0], headers[1], headers[2], headers[3], headers[4]);
                if (responses && responses.length > 0) {
                    console.log(responses);
                    return kpiCoreNetworkGraphSuccess(responses, false, true);
                }
            } catch (error) {
                console.log(error);
                return graphDataRadioApiError('metrix data not available', null);
            }
        })
    );
export const rootEpic = combineEpics(
    pingEpic,
    kpiListEpic,
    kpiLoadSuccess,
    requestEpgCoreNetworkEpic,
    requestMMECoreNetworkEpic,
    requestSA5GCoreNetworkEpic,
    requestNDACCoreNetworkEpic
);
